import type { RequestOptions } from '@umijs/max';
import { request } from '@umijs/max';
import type { ResStruct } from '@/services/type';

/**
 * 登录
 */
export function login(data: API.ILoginParams, op?: RequestOptions) {
  return request<ResStruct<API.ITokenData>>(`/api/auth/login`, {
    method: 'post',
    data,
    ...op,
  });
}

/**
 * 获取极验信息
 */
export function getGeetestCode(op?: RequestOptions) {
  return request<ResStruct>(`/api/code`, {
    method: 'get',
    ...op,
  });
}

/**
 * 退出登录
 */
export function deleteLogout(op?: RequestOptions) {
  return request<ResStruct<null>>(`/api/auth/logout`, {
    method: 'delete',
    ...op,
  });
}

/**
 * 邮箱登陆
 */
export function emailLogin(data: API.IEmailLoginParams, op?: RequestOptions) {
  return request<ResStruct<API.ITokenData>>(`/api/auth/email_verification_login`, {
    method: 'post',
    data,
    ...op,
  });
}

/**
 * 谷歌登陆
 */
export function googleLogin(data: API.IGoogleLoginParams, op?: RequestOptions) {
  return request<ResStruct<API.ITokenData>>(`/api/auth/google_login`, {
    method: 'post',
    data,
    ...op,
  });
}

/**
 * 发送验证码
 */
export function sendVerificationCode(data: API.ISendVerificationCodeParams, op?: RequestOptions) {
  return request<ResStruct>(`/api/auth/send_verification_code`, {
    method: 'post',
    data,
    ...op,
  });
}

/**
 * 谷歌状态
 */
export function googleStatus(data: API.IGoogleStatusParams, op?: RequestOptions) {
  return request<ResStruct>(`/api/auth/google_status`, {
    method: 'post',
    data,
    skipErrorHandler: true,
    ...op,
  });
}

/**
 * 获取手机号区号列表
 */
export function getAreaCode(op?: RequestOptions) {
  return request<ResStruct<API.IAreaCodeItem[]>>(`/api/business/areaCode/getAreaCode`, {
    method: 'get',
    ...op,
  });
}

/**
 * 首次登录强制修改密码，不需要谷歌验证码
 */
export function firstUpdatePassword(data: { newPassword: string }, op?: RequestOptions) {
  return request<ResStruct>(`/api/system/user/editMyPassword`, {
    method: 'put',
    data,
    ...op,
  });
}
